/// <amd-module name="TFS/Admin/Common/RestClient/NewDomainUrlMigration" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\cloud.webapi\httpclients\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as NewDomainUrlMigration from "TFS/Admin/Common/Contracts/NewDomainUrlMigration";

export interface INewDomainUrlMigrationRestClient extends IVssRestClient {
    /**
     * @param requestId - 
     */
    cancelRequest(requestId: string): Promise<void>;
    /**
     * @param requestId - 
     */
    getRequestStatus(requestId: string): Promise<NewDomainUrlMigration.ServicingOrchestrationRequestStatus>;
    /**
     * @param request - 
     */
    queueRequest(request: NewDomainUrlMigration.FrameworkNewDomainUrlMigrationRequest): Promise<void>;
    /**
     * @param request - 
     */
    validateRequest(request: NewDomainUrlMigration.FrameworkNewDomainUrlMigrationRequest): Promise<void>;
}

class NewDomainUrlMigrationRestClient extends RestClientBase implements INewDomainUrlMigrationRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param requestId - 
     */
    public async cancelRequest(
        requestId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/ServicingOrchestration/NewDomainUrlMigration/Requests/{requestId}",
            routeValues: {
                requestId: requestId
            }
        });
    }

    /**
     * @param requestId - 
     */
    public async getRequestStatus(
        requestId: string
        ): Promise<NewDomainUrlMigration.ServicingOrchestrationRequestStatus> {

        return this.beginRequest<NewDomainUrlMigration.ServicingOrchestrationRequestStatus>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/ServicingOrchestration/NewDomainUrlMigration/Requests/{requestId}",
            routeValues: {
                requestId: requestId
            }
        });
    }

    /**
     * @param request - 
     */
    public async queueRequest(
        request: NewDomainUrlMigration.FrameworkNewDomainUrlMigrationRequest
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/ServicingOrchestration/NewDomainUrlMigration/Requests/{requestId}",
            body: request
        });
    }

    /**
     * @param request - 
     */
    public async validateRequest(
        request: NewDomainUrlMigration.FrameworkNewDomainUrlMigrationRequest
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/ServicingOrchestration/NewDomainUrlMigration/Requests/{requestId}",
            body: request
        });
    }

}

export const NewDomainUrlMigrationClientName = "INewDomainUrlMigrationRestClient";

export function getNewDomainUrlMigrationClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): INewDomainUrlMigrationRestClient {
    return pageContext.getRestClient<INewDomainUrlMigrationRestClient>(NewDomainUrlMigrationClientName, options);
}

RestClients.add(NewDomainUrlMigrationClientName, { 
    factory: NewDomainUrlMigrationRestClient,
    options: {
        serviceInstanceType: "951917ac-a960-4999-8464-e3f0aa25b381"
    }
});
